import fetch from '../../../services/fetch';

const state = {
  financialSummary: {
    status: '',
    summary: {}
  }
};

const getters = {
  financialSummary: (state) => state.financialSummary,
};

const actions = {
  async getFinancialSummary ({ commit, dispatch }) {
    commit('setFinancialStatus', 'loading')

    const financialSummary = await fetch.get('/financial-summary').then(res => res.data)

    commit('setFinancialSummary', {
      status: 'loaded',
      summary: financialSummary
    })
  },
};

const mutations = {
  setFinancialStatus: (state, status) => (state.financialSummary.status = status),
  setFinancialSummary: (state, summary) => (state.financialSummary = summary),
};

export default {
  state,
  getters,
  actions,
  mutations
}